import './grid/grid'

import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import ptBR from './i18n/pt_br'
import enUS from './i18n/en_us'

const localeFiles = {
    pt_br: ptBR,
    en_us: enUS
}

// register current locale file
i18n.add(localeFiles[locale])
